export interface CheckReturnCollectionRequest {
  collections: {
    id: number // 資料ID
    collectionNo: string
    shelfType: string
    appendixLendFlag: boolean | null
    handlingType: string
    _deleteHandlingType: boolean
  }[]
}

export function CheckReturnCollectionToJSON(
  value: CheckReturnCollectionRequest
): any {
  return {
    collections:
      value.collections.length !== 0
        ? value.collections.map(collection => {
            return {
              id: collection.id !== 0 ? collection.id : undefined,
              collection_no:
                collection.collectionNo !== ''
                  ? collection.collectionNo
                  : undefined,
              shelf_type:
                collection.shelfType !== '' ? collection.shelfType : undefined,
              appendix_lend_flag: collection.appendixLendFlag ?? undefined,
              handling_type:
                collection.handlingType !== ''
                  ? collection.handlingType
                  : undefined,
              _delete_handling_type: collection._deleteHandlingType ?? undefined
            }
          })
        : undefined
  }
}
